import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/warningTriangle.svg
var n = (n) => /* @__PURE__ */ t("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...n,
	children: [/* @__PURE__ */ e("g", {
		clipPath: "url(#clip0_817_186)",
		children: /* @__PURE__ */ e("path", {
			fill: "#1f2830",
			d: "M23.73 20.279 14.3 1.422a2.572 2.572 0 0 0-4.6 0L.27 20.279A2.572 2.572 0 0 0 2.571 24H21.43a2.572 2.572 0 0 0 2.3-3.722M10.715 8.572a1.286 1.286 0 0 1 2.571 0v5.143a1.285 1.285 0 1 1-2.571 0zm1.285 12a1.715 1.715 0 1 1 0-3.43 1.715 1.715 0 0 1 0 3.43"
		})
	}), /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", {
		id: "clip0_817_186",
		children: /* @__PURE__ */ e("rect", {
			width: 24,
			height: 24,
			fill: "#fff"
		})
	}) })]
});
//#endregion
export { n as default };
